<div class="relative">
  <div class="container w-[260px] min-w-full">
    <!-- Header -->
    <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
      <div class="flex items-center gap-3 w-full">
        <tui-svg src="tuiIconBriefcase" style="color: black;"></tui-svg>
        <h3 class="flex items-center text-black text-[1.5rem] font-bold">Sales</h3>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <button tuiButton appearance="" (click)="toggle()">
          <div class="flex justify-center items-center btn-outline w-[80px] sm:w-[160px]">
            <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
              style="color: #bb0021;"></tui-svg>
            <p class="hidden sm:block">Advanced Search</p>
          </div>
        </button>
        <button tuiButton appearance="" (click)="navigateToAdd()">
          <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
            <p class="flex justify-center items-center text-[13px] h-[24px]">Add Sale</p>
          </div>
        </button>
        <button tuiButton appearance="primary" class="btn-outline" (click)="downloadTableExcel()">
          <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline"
            (click)="downloadTableExcel()">
            <tui-svg src="tuiIconDownloadLarge" class="mr-2"></tui-svg>
            <p class="flex justify-center items-center text-[13px] h-[24px]">Download Excel</p>
          </div>
        </button>
      </div>
    </div>

    <!-- Advanced Search -->
    <div class="mt-2 sm:mt-0 mb-3" *ngIf="showSearch">
      <div class="flex flex-col lg:flex-row justify-between gap-3 sm:items-center">
        <div class="flex sm:items-center gap-1 flex-col sm:flex-row w-full">
          <!-- Search Text -->
          <div class="w-full sm:w-60">
            <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="true" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [(ngModel)]="searchText" placeholder="Search Item"
              (tuiValueChanges)="cancelSearch($event)">
              Search
              <input tuiTextfield type="text" />
            </tui-input>
          </div>

          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>

          <!-- Date Range -->
          <div class="w-full sm:w-60 py-3">
            <tui-input-date-range [(ngModel)]="dateFilter" tuiTextfieldSize="m" placeholder="Choose Dates">
              Choose dates
            </tui-input-date-range>
          </div>

          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>

          <!-- Search Button -->
          <div class="w-full sm:w-[100px]">
            <button tuiButton tuiTextfieldSize="s" type="button"
              class="w-full btn-outline text-black bg-white hover:bg-[#bb0021] hover:text-white" (click)="search()">
              <tui-svg src="tuiIconSearchLarge" class="pr-2"></tui-svg>
              Search
            </button>
          </div>
        </div>
      </div>

      <!-- Status message -->
      <div class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2 w-full" *ngIf="statusMsg">
        <div class="flex items-center">
          <img src="/assets/img/resulticon.png" alt="">
          <p class="text-black pl-2">{{ showText() }}</p>
        </div>
        <div>
          <button class="text-[#bb0021] hover:scale-110 transition-all duration-100"
            (click)="resetStatus()">Reset</button>
        </div>
      </div>
    </div>

    <!-- Sales Table -->
    <div class="mt-3">
      <tui-loader [overlay]="true" [showLoader]="isLoading">
        <div *ngIf="filteredList.length > 0" class="overflow-x-scroll" style="white-space: nowrap">
          <table class="tui-table w-full">
            <thead tuiThead>
              <tr class="tui-table__tr">
                <th class="tui-table__th">Date</th>
                <th class="tui-table__th">Item Name</th>
                <th class="tui-table__th">Quantity</th>
                <th class="tui-table__th">Unit Price (LKR)</th>
                <th class="tui-table__th">Total Price (LKR)</th>
                <th class="tui-table__th">Payment Method</th>
                <th class="tui-table__th">Payment Verification</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tui-table__tr" *ngFor="let sale of filteredList.slice((pageSize.pageIndex-1)*10, pageSize.pageIndex*10)">
                <td class="tui-table__td">{{ sale.date | date: 'yyyy-MM-dd' }}</td>
                <td class="tui-table__td">{{ sale.itemName }}</td>
                <td class="tui-table__td">x{{ sale.quantity }}</td>
                <td class="tui-table__td">{{ sale.unitPrice | number: '1.2-2' }}</td>
                <td class="tui-table__td">{{ sale.totalPrice | number: '1.2-2' }}</td>
                <td class="tui-table__td">{{ sale.paymentMethod }}</td>
                <td class="tui-table__td">
                  <div class="flex items-center gap-2">
                    <input type="checkbox" [(ngModel)]="sale.tempVerified" [disabled]="sale.paymentVerified"
                      (change)="verifyPayment(sale)" />
                    <span [style.color]="sale.paymentVerified ? '#4AC99B' : '#FF4646'">
                      {{ sale.paymentVerified ? 'Verified' : 'Not Verified' }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="filteredList.length === 0 && !isLoading" class="mt-3">
          <p class="text-[#D8D8D8] text-center">No Data</p>
        </div>
      </tui-loader>
    </div>

    <!-- Pagination -->
    <div class="text-black py-10 flex justify-end w-full max-w-full">
      <tui-pagination [index]="pageSize.pageIndex-1" [length]="pageSize.length" (indexChange)="goToPage($event)">
      </tui-pagination>
    </div>
  </div>
</div>